import { AppContext, Icon } from '@nile/components';
import React, { useCallback, useContext, useState } from 'react';
import {
  Avatar,
  Heading,
  ResourceItem,
  ResourceList,
  TextStyle
} from '@shopify/polaris';
import { Popover, Link } from '@superops/ui-design-system';
import styled from 'styled-components';
import { LogOutCircle } from '@styled-icons/boxicons-regular';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import envConfig from '@nile/home/src/Config/env';

const StyledHeading = styled(Heading)`
  cursor: pointer;
`;

const LogoutItem = (props) => {
  const { item, main } = props;
  const media = <Avatar customer size="medium" name={item.name} />;
  return (
    <Link url={`${main.conf.loginRoot}/logout`} removeUnderline>
      <TextStyle variation="strong">{item.name}</TextStyle>
    </Link>
  );
};

const FeedbackItem = (props) => {
  const { main } = props;
  return (
    <div
      onClick={() => {
        main.tabRef.current.openTabCb({
          module: 'CANNY_FEEDBACK'
        });
      }}
    >
      Feedback
    </div>
  );
};

const UserAppMenu = (props) => {
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(
    () => setPopoverActive((popoverActive) => !popoverActive),
    []
  );

  const { tabRef } = props;

  const activator = (
    <span onClick={togglePopoverActive}>
      <Avatar customer size="medium" name={'LG'} />
    </span>
  );

  const appContext = useContext(AppContext);
  const { user, accountType } = appContext;

  /* Hotjar tracking code */
  // user?.subscriptionStatus === 'TRIAL'
  if (
    props.flags?.hotjar &&
    document.getElementsByClassName('hotjar').length === 0
  ) {
    document.getElementsByTagName('head')[0].appendChild(props.hotjarScript);
  }

  return (
    <div>
      <Popover
        active={popoverActive}
        activator={activator}
        onClose={togglePopoverActive}
      >
        <Popover.Pane fixed>
          <Popover.Section>
            <StyledHeading>
              <div
                className="pointer"
                onClick={() => {
                  props.history.push(
                    accountType === 'CLIENT'
                      ? '/profile/detail/edit'
                      : '/onboard/profile'
                  );
                  togglePopoverActive();
                }}
              >
                {`${user?.firstName} ${user?.lastName}`}
              </div>
            </StyledHeading>
          </Popover.Section>
        </Popover.Pane>
        <Popover.Pane>
          <UserMenuWrapper>
            <ResourceList
              resourceName={{ singular: 'action', plural: 'actions' }}
              items={[
                {
                  id: 1,
                  name: 'Feedbkack',
                  Element: FeedbackItem,
                  enabled: true,
                  ShortcutActions: (prop) => {
                    return <span {...prop} />;
                  }
                },
                {
                  id: 0,
                  name: 'Logout',
                  Element: LogoutItem,
                  enabled: true,
                  ShortcutActions: (prop) => {
                    return (
                      <div {...prop}>
                        <Icon
                          style={{ width: 22, height: 22, color: '#000000' }}
                          icon={LogOutCircle}
                        />
                      </div>
                    );
                  }
                }
              ]}
              renderItem={(item) => {
                const { id, name, enabled, Element, ShortcutActions } = item;

                return enabled ? (
                  <ResourceItem
                    id={id}
                    accessibilityLabel={`View details for ${name}`}
                  >
                    <div className="MenuItem flex center">
                      <Element item={item} main={props} />
                      <ShortcutActions className="flex full-width jend" />
                    </div>
                  </ResourceItem>
                ) : null;
              }}
            />
          </UserMenuWrapper>
        </Popover.Pane>
      </Popover>
    </div>
  );
};

const UserMenuWrapper = styled.div`
  .MenuItem {
    position: relative;
    top: 6px;
  }
  .Polaris-ResourceList__ItemWrapper:first-child {
    display: none;
  }
`;

export default withLDConsumer()(UserAppMenu);
